export default __webpack_public_path__ + "static/media/comment-alt-lines.d32bb8ed.svg";